// assets/nd-export-ssot-engine.js
// ND Export SSOT Engine v1.0
// ------------------------------------------------------------
// PURPOSE:
// - Single Source of Truth for export pricing (PDF / XLSX)
// - Eliminate rounding mismatch (±0.01)
// - DO NOT trust Shopify cart price or final_price
//
// RULES (LOCKED):
// 1) One cart = one factor
// 2) No base product price; ALL prices come from options
// 3) Each option:
//    raw_cents * factor -> round(cents)
// 4) Unit price = SUM(option final cents)
// 5) Line price = unit price * qty
// ------------------------------------------------------------

(function () {
  if (window.__ND_EXPORT_SSOT_ENGINE__) return;
  window.__ND_EXPORT_SSOT_ENGINE__ = true;

  /**
   * Normalize cents input
   */
  function toCents(v) {
    const n = Number(v);
    return Number.isFinite(n) ? Math.round(n) : 0;
  }

  /**
   * Core SSOT calculator
   *
   * @param {Object} params
   * @param {Array}  params.options   - option list (must include raw price in cents)
   * @param {Number} params.factor    - single factor for whole cart
   * @param {Number} params.qty       - item quantity
   *
   * @returns {Object}
   * {
   *   options: [{ name, value, rawCents, finalCents }],
   *   unitCents,
   *   lineCents
   * }
   */
  function calcSSOT({ options = [], factor = 1, qty = 1 }) {
  const f = Number(factor);
  const q = Math.max(1, Number(qty) || 1);

  let unitRawCents = 0;
  const outOptions = [];

  options.forEach(opt => {
    const rawCents =
      toCents(
        opt.rawCents ??
        opt.price_cents ??
        opt.priceCents ??
        opt.cents ??
        0
      );

    unitRawCents += rawCents;

    outOptions.push({
      ...opt,
      rawCents
    });
  });

  // ✅ 正確邏輯：整個商品加總後才乘 factor
  const unitAfterCents = Math.round(unitRawCents * f);

  return {
    options: outOptions,
    unitRawCents,
    unitCents: unitAfterCents,
    lineCents: unitAfterCents * q
  };
}

  /**
   * Public API
   * PDF / XLSX exporter should ONLY use this
   */
  window.ND_EXPORT_SSOT = {
    calc: calcSSOT
  };
})();
